import { STATUS } from '@/utils/static/kyc';
import { api } from '@/api';

//QUESTIONNAIRES
const generateQuestionnaires = () => {
  return api.post('/api/kyc/v1/investor/questionSectionTypes');
};
const getQuestionnaires = () => {
  return api.get('/api/kyc/v1/investor/questionSectionTypes');
};
const checkQuestionnaireStatus = ({ id, rejectedSettings }) => {
  return api.post('/api/kyc/v1/investor/checkQuestionnaire', {
    questionSectionTypeId: id,
    rejectedSettings: rejectedSettings
  });
};
const checkQuestionnaireStatusForAdmin = ({ id, rejectedSettings, investorId }) => {
  return api.post('/api/kyc/v1/admin/investor/checkQuestionnaire', {
    questionSectionTypeId: id,
    rejectedSettings: rejectedSettings,
    investorId: investorId
  });
};
const getRejectedEntities = () => {
  return api.get('/api/kyc/v1/investor/questionnaire', {
    params: { status: STATUS.REJECTED }
  });
};
const getRejectedEntitiesForAdmin = (investorId) => {
  return api.get('/api/kyc/v1/admin/questionnaire', {
    params: {
      status: STATUS.REJECTED,
      investorId: investorId
    }
  });
};
const saveAnswers = ({ answers, files }) => {
  const formData = new FormData();
  formData.append('answers', JSON.stringify(answers));

  if (!!Object.keys(files).length) {
    for (const [key, value] of Object.entries(files)) {
      formData.append(key, value);
    }
  }

  return api.post('/api/kyc/v1/investor/answers', formData);
};
const saveAnswersForAdmin = ({ answers, files, investorId }) => {
  const formData = new FormData();
  formData.append('answers', JSON.stringify(answers));
  formData.append('investorId', investorId);

  if (!!Object.keys(files).length) {
    for (const [key, value] of Object.entries(files)) {
      formData.append(key, value);
    }
  }

  return api.post('/api/kyc/v1/admin/investor/answers', formData);
};
const getAllowedQuestsToAdd = () => {
  return api.get('/api/kyc/v1/investor/questionnaires');
};
const requestQuest = ({ questId }) => {
  return api.post('/api/kyc/v1/investor/questionnaires', {
    questionSectionTypeId: questId
  });
};

//SUMSUB
const createVerificationInstance = () => api.post('/api/kyc/v1/investor/questionSectionTypes');
const getSumSubQuestionnaire = () => {
  return api.get('/api/kyc/v1/investor/verification/questionnaire');
};
const postSumSubAnswer = ({ questionId, file, availableAnswerId, answer, clearAll }) => {
  const formData = new FormData();
  formData.append('questionId', questionId);
  if (file) formData.append('file', file);
  if (availableAnswerId) formData.append('availableAnswerId', availableAnswerId);
  if (answer) formData.append('answer', answer);
  if (clearAll) formData.append('clearAll', clearAll);

  return api.post('/api/kyc/v1/investor/verification/questionnaire/answer', formData);
};
const postSumSubAnswers = ({ answers, files, questionSectionId }) => {
  const formData = new FormData();
  formData.append('questionSectionId', questionSectionId);
  formData.append('answers', JSON.stringify(answers));

  if (!!Object.keys(files).length) {
    for (const [key, value] of Object.entries(files)) {
      formData.append(key, value);
    }
  }

  return api.post('/api/kyc/v1/investor/verification/questionnaire/answers', formData);
};
const getSumSubStatus = () => {
  return api.get('/api/kyc/v1/investor/verification/status');
};
const startSumSubCheck = () => {
  return api.get('/api/kyc/v1/sumsub/verification/check');
};
const readSumSubTooltip = ({ questionSectionId }) => {
  return api.put('/api/kyc/v1/investor/verification/tooltip/read', {
    questionSectionId
  });
};
const getVerificationPhotos = (questionSectionId) => {
  return api.get('/api/kyc/v1/investor/verification/session/photos', {
    params: {
      questionSectionId
    }
  });
};
const getVerificationPhoto = ({ questionSectionId, mediaId }) => {
  return api.get('/api/kyc/v1/investor/verification/session/photo', {
    params: {
      questionSectionId,
      mediaId
    }
  });
};
//VERIF
const getVeriffLink = (questionSectionId) =>
  api.post('/api/kyc/v1/investor/verification/session/link', {
    questionSectionId
  });

//DOCS
//requested docs
const getRequestedDocuments = () => {
  return api.get('/api/kyc/v1/investor/questionnaire/document/requestDocuments');
};
//docs from questionnaires
const getQuestsDocuments = () => {
  return api.get('/api/kyc/v1/investor/questionnaire/document/documentAnswers');
};
//allowed doc sections to add
const getDocumentsSections = () => {
  return api.get('/api/kyc/v1/investor/questionnaire/document/sections');
};
//allowed doc types to add by section
const getDocumentSectionTypes = ({ sectionId }) => {
  return api.get('/api/kyc/v1/investor/questionnaire/document/types', {
    params: { kycDocumentSectionId: sectionId }
  });
};
//get doc request by id
const getDocumentRequest = (requestId) => {
  return api.get('/api/kyc/v1/investor/questionnaire/document/requestDocument', {
    params: { requestDocumentId: requestId }
  });
};
//create upload doc request
const requestDocument = ({ docTypeId }) => {
  return api.post('/api/kyc/v1/investor/questionnaire/document/requestDocument', {
    kycTypeDocumentId: docTypeId
  });
};
//upload doc
const uploadDocument = ({ requestDocumentId, file }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('requestDocumentId', requestDocumentId);
  formData.append('documentName', file.name);

  return api.post('/api/kyc/v1/investor/questionnaire/document', formData);
};
//ACTIVITY
const getInvestorActivity = (params) => {
  return api.get('/api/kyc/v1/admin/questionnaire/logs', { params: { ...params } });
};

const getQuestionnaireSections = (id) => {
  return api.get('/api/kyc/v1/investor/questionSectionTypes/questions', {
    params: { questionSectionTypeId: id }
  });
};
const getQuestionnaireSectionsForAdmin = (id, investorId) => {
  return api.get('/api/kyc/v1/admin/investor/questionSectionTypes/questions', {
    params: { questionSectionTypeId: id, investorId: investorId }
  });
};
const getAllowedProductsToAdd = () => {
  return api.get('/api/kyc/v1/investor/products');
};
const getMyProducts = () => {
  return api.get('/api/kyc/v1/investor/products/my');
};
const requestProduct = (productId) => {
  return api.post('/api/kyc/v1/investor/products', { productId });
};
const getProductsSections = (id) => {
  return api.get('/api/kyc/v1/investor/products/questions', {
    params: { investorProductId: id }
  });
};
const getProductsSectionsForAdmin = (id, investorId) => {
  return api.get('/api/kyc/v1/admin/investor/products/questions', {
    params: { investorProductId: id, investorId: investorId }
  });
};
const saveQuestionProduct = ({
  productQuestionId,
  investorProductId,
  file,
  availableAnswerId,
  answer,
  clearAll,
  group
}) => {
  const formData = new FormData();
  formData.append('investorProductId', investorProductId);
  formData.append('productQuestionId', productQuestionId);
  if (clearAll) formData.append('clearAll', clearAll);
  if (file) formData.append('file', file);
  if (availableAnswerId) formData.append('productAvailableAnswerId', availableAnswerId);
  if (answer) formData.append('answer', answer);
  if (group || group >= 0) formData.append('group', group);

  return api.post('/api/kyc/v1/investor/products/answer ', formData);
};
const saveQuestionProductForAdmin = ({
  productQuestionId,
  investorProductId,
  file,
  availableAnswerId,
  answer,
  clearAll,
  group,
  investorId
}) => {
  const formData = new FormData();
  formData.append('productQuestionId', productQuestionId);
  formData.append('investorProductId', investorProductId);
  formData.append('investorId', investorId);
  if (clearAll) formData.append('clearAll', clearAll);
  if (file) formData.append('file', file);
  if (availableAnswerId) formData.append('productAvailableAnswerId', availableAnswerId);
  if (answer) formData.append('answer', answer);
  if (group || group >= 0) formData.append('group', group);

  return api.post('/api/kyc/v1/admin/investor/products/answer', formData);
};
const setPreProcessingStatus = ({ id }) => {
  return api.post('/api/kyc/v1/investor/products/preProcessing', {
    investorProductId: id
  });
};
const setPreProcessingStatusForAdmin = ({ id, investorId }) => {
  return api.post('/api/kyc/v1/admin/investor/products/preProcessing', {
    investorProductId: id,
    investorId: investorId
  });
};
const checkProductStatus = ({ id }) => {
  return api.post('/api/kyc/v1/investor/products/checkProduct', {
    investorProductId: id
  });
};
const checkProductStatusForAdmin = ({ id, investorId }) => {
  return api.post('/api/kyc/v1/admin/investor/products/checkProduct', {
    investorProductId: id,
    investorId: investorId
  });
};
const getRejectedProductEntities = () => {
  return api.get('/api/kyc/v1/investor/products/questions/status', {
    params: { status: STATUS.REJECTED }
  });
};
const getRejectedProductEntitiesForAdmin = (investorId) => {
  return api.get('/api/kyc/v1/admin/investor/products/questions/status', {
    params: {
      status: STATUS.REJECTED,
      investorId: investorId
    }
  });
};
const getMyReferralProducts = (token) => {
  return api.get('/api/kyc/v1/agent/products/my', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
const getReferralProductsSections = (token, id) => {
  return api.get('/api/kyc/v1/agent/products/questions', {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: { investorProductId: id }
  });
};
const getReferralQuestionnaires = (token) => {
  return api.get('/api/kyc/v1/agent/questionSectionTypes', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
const getReferralQuestionnaireSections = (token, id) => {
  return api.get('/api/kyc/v1/agent/questionSectionTypes/questions', {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: { questionSectionTypeId: id }
  });
};
const getReferralRequestedDocuments = (token) => {
  return api.get('/api/kyc/v1/agent/document/requestDocuments', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
const getReferralQuestsDocuments = (token) => {
  return api.get('/api/kyc/v1/agent/document/documentAnswers', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
const getReferralDocumentRequest = (token, requestId) => {
  return api.get('/api/kyc/v1/agent/document/requestDocument', {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: { requestDocumentId: requestId }
  });
};
const saveReferralQuestionProduct = ({
  token,
  productQuestionId,
  investorProductId,
  creatorId,
  file,
  availableAnswerId,
  answer,
  clearAll,
  group
}) => {
  const formData = new FormData();
  formData.append('investorProductId', investorProductId);
  formData.append('productQuestionId', productQuestionId);
  formData.append('creatorId', creatorId);
  if (clearAll) formData.append('clearAll', clearAll);
  if (file) formData.append('file', file);
  if (availableAnswerId) formData.append('productAvailableAnswerId', availableAnswerId);
  if (answer) formData.append('answer', answer);
  if (group || group >= 0) formData.append('group', group);

  return api.post('/api/kyc/v1/agent/products/answer', formData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
const checkReferralProductStatus = ({ token, id }) => {
  return api.post(
    '/api/kyc/v1/agent/products/checkProduct',
    {
      investorProductId: id
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};
const setReferralPreProcessingStatus = ({ token, id }) => {
  return api.post(
    '/api/kyc/v1/agent/products/preProcessing',
    {
      investorProductId: id
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};

const saveReferralAnswers = ({ answers, files, creatorId, token }) => {
  const formData = new FormData();
  formData.append('answers', JSON.stringify(answers));
  formData.append('creatorId', creatorId);

  if (!!Object.keys(files).length) {
    for (const [key, value] of Object.entries(files)) {
      formData.append(key, value);
    }
  }

  return api.post('/api/kyc/v1/agent/questionSectionTypes/answers', formData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
const checkReferralQuestionnaireStatus = ({ token, id, rejectedSettings }) => {
  return api.post(
    '/api/kyc/v1/agent/questionSectionTypes/checkQuestionnaire',
    {
      questionSectionTypeId: id,
      rejectedSettings: rejectedSettings
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};
const requestReferralDocument = ({ token, docTypeId }) => {
  return api.post(
    '/api/kyc/v1/agent/document/requestDocument',
    {
      kycTypeDocumentId: docTypeId
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};
const uploadReferralDocument = ({ token, requestDocumentId, file }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('requestDocumentId', requestDocumentId);

  return api.post('/api/kyc/v1/agent/document/document', formData, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
const getReferralAllowedQuestsToAdd = (token) => {
  return api.get('/api/kyc/v1/agent/questionSectionTypes/questionnaires', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
const requestReferralQuest = ({ token, questId }) => {
  return api.post(
    '/api/kyc/v1/agent/questionSectionTypes/questionnaires',
    {
      questionSectionTypeId: questId
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};
const getReferralScoring = (token, questionSectionTypeId) => {
  return api.get('/api/kyc/v1/agent/scoring/questionSectionType', {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      questionSectionTypeId: questionSectionTypeId
    }
  });
};
const markAnswersAsFixed = ({ answersId, questionSectionTypeId }) => {
  return api.put('/api/kyc/v1/investor/questionnaires/answers/fixed', {
    answersId: answersId,
    questionSectionTypeId: questionSectionTypeId
  });
};

export const kycApi = {
  generateQuestionnaires,
  getQuestionnaires,
  getSumSubQuestionnaire,
  getAllowedQuestsToAdd,
  requestQuest,
  createVerificationInstance,
  postSumSubAnswer,
  postSumSubAnswers,
  getSumSubStatus,
  startSumSubCheck,
  readSumSubTooltip,
  getRequestedDocuments,
  getQuestsDocuments,
  getDocumentsSections,
  getDocumentSectionTypes,
  getDocumentRequest,
  requestDocument,
  uploadDocument,
  getInvestorActivity,
  getQuestionnaireSections,
  getQuestionnaireSectionsForAdmin,
  checkQuestionnaireStatus,
  checkQuestionnaireStatusForAdmin,
  getRejectedEntities,
  getRejectedEntitiesForAdmin,
  saveAnswers,
  saveAnswersForAdmin,
  setPreProcessingStatus,
  setPreProcessingStatusForAdmin,
  getAllowedProductsToAdd,
  getMyProducts,
  requestProduct,
  getProductsSections,
  saveQuestionProduct,
  saveReferralQuestionProduct,
  checkProductStatus,
  saveQuestionProductForAdmin,
  checkProductStatusForAdmin,
  getRejectedProductEntities,
  getProductsSectionsForAdmin,
  getRejectedProductEntitiesForAdmin,
  getMyReferralProducts,
  getReferralProductsSections,
  getReferralQuestionnaires,
  getReferralQuestionnaireSections,
  getReferralRequestedDocuments,
  getReferralQuestsDocuments,
  getReferralDocumentRequest,
  checkReferralProductStatus,
  setReferralPreProcessingStatus,
  saveReferralAnswers,
  checkReferralQuestionnaireStatus,
  requestReferralDocument,
  uploadReferralDocument,
  getReferralAllowedQuestsToAdd,
  requestReferralQuest,
  getVeriffLink,
  getVerificationPhotos,
  getVerificationPhoto,
  markAnswersAsFixed,
  getReferralScoring
};
